<template>
    <v-select
        dense
        outlined
        :clearable="clearable"
        hide-details="auto"
        v-model="local_value"
        :items="items"
        :label="label || $t('Unit')"
        item-text="name"
        item-value="id"
        return-object
    ></v-select>
</template>
  
<script>
import unitService from '@/service/unit-service';
  
export default {
    props: {
        value: Number,
        label: String,
        unitType: {
            type: Number,
            required: false
        },
        liquid: {
            type: Boolean,
            default: false
        },
        weight: {
            type: Boolean,
            default: false
        },
        iu: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        medicamentCode: {
            type: Number,
            required: false
        }
    },
    data() {
        return {
            local_value: null,
            items: []
        };
    },
    async mounted() {
        await this.getData({ unitType: this.unitType }).then((response) => {
            this.items = response;
            if (this.value && this.items && this.items.length > 0) {
                this.local_value = this.items.find(i => i.id === this.value);
            } else {
                this.local_value = null;
            }
        });
    },
    watch: {
        value(val) {
            if (this.items && this.items.length > 0) {
                this.local_value = this.items.find(i => i.id === val);
            }
        },
        local_value(val, oldValue) {
            if (val != oldValue) {
                this.handleInput();
            }
        },
        unitType(val) {
            this.loadData({ unitType: val });
        },
        liquid() {
            this.loadData({ unitType: this.unitType });
        },
        weight() {
            this.loadData({ unitType: this.unitType });
        },
        iu() {
            this.loadData({ unitType: this.unitType });
        },
    },
    methods: {
        loadData(filter) {
            this.getData(filter).then((response) => {
                this.items = response;
                this.local_value = null;
            });
        },
        async getData(filter) {
            let unitTypes = [];
            if (filter.unitType) {
                unitTypes.push(filter.unitType);
            }
            if (this.liquid) {
                unitTypes.push(2);
                filter.includeLiquid = true;
            }
            if (this.weight) {
                unitTypes.push(1);
                filter.includeWeight = true;
            }
            if (this.iu) {
                unitTypes.push(12);
                filter.includeIu = true;
            }
            if (this.medicamentCode > 0) {
                filter.medicamentCode = this.medicamentCode;
            }
            if (!filter.medicamentCode) {
                if (unitTypes.length > 0) {
                    return await unitService.data.byTypes(unitTypes);
                }
                return await unitService.data.all();
            }
            return (await unitService.getData(filter)).data;
        },
        handleInput() {
            this.$emit('input', this.local_value ? this.local_value.id : null);
            this.$emit('unit', this.local_value);
        }
    }
};
</script>

<style>
</style>